import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { insurersFetch } from './action';
import { selectFeatureInsurer } from './selector';

export const useInsurersFetch = () => {
  const dispatch = useDispatch();
  const { insurers } = useSelector(selectFeatureInsurer);

  useEffectOnce(() => {
    if (!isEmpty(insurers)) return;
    dispatch(insurersFetch());
  });

  return insurers;
};
